export default "__VITE_ASSET__f3470639__"